import { useEffectOnce } from "./hooks/useeffectonce";
import store from "./redux/store";
import { Provider } from "react-redux";
import { setInternetStatus } from "./redux/slices/internetstatusslice";
import { addNotification } from "./redux/slices/notificationsslice";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./routing/routes";
import { injectStore } from "./api/httpclient";
import { NotificationsManager } from "./components/notificationsmanager";
import { ThemeManager } from "./components/thememanager";
import { AppLoader } from "./components/apploader";
import { WelcomeScreen } from "./components/welcomescreen";
import { AppInit } from "./components/appinit";
import { Dictaphone } from "./components/dictaphone";
import { AppDialog } from "./components/appdialog";
import {
  notificationDurationShort,
  notificationDurationMiddle,
  notificationDurationLong,
} from "./lib/utils";
import { MESSAGES } from "./settings";

import "@progress/kendo-theme-default/dist/all.css";
import "./App.css";
import { IntlProvider, load } from '@progress/kendo-react-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import numbers from 'cldr-numbers-full/main/en-GB/numbers.json';
import caGregorian from 'cldr-dates-full/main/en-GB/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/en-GB/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/en-GB/timeZoneNames.json';


load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames
);
//inject store in axios instance
injectStore(store);

//handle online/offline
if (window.addEventListener) {
  window.addEventListener("online", () => {
    store.dispatch(setInternetStatus(true));
    store.dispatch(
      addNotification({
        type: "success",
        text: MESSAGES.youAreOnline,
        duration: notificationDurationShort,
        closable: true,
      })
    );
  });

  window.addEventListener("offline", () => {
    store.dispatch(setInternetStatus(false));
    store.dispatch(
      addNotification({
        type: "error",
        text: MESSAGES.youAreOffline,
        duration: notificationDurationShort,
        closable: true,
      })
    );
  });
} else {
  window.ononline = () => {
    store.dispatch(setInternetStatus(true));
    store.dispatch(
      addNotification({
        type: "success",
        text: MESSAGES.youAreOnline,
        duration: notificationDurationShort,
        closable: true,
      })
    );
  };

  window.onoffline = () => {
    store.dispatch(setInternetStatus(false));
    store.dispatch(
      addNotification({
        type: "error",
        text: MESSAGES.youAreOffline,
        duration: notificationDurationShort,
        closable: true,
      })
    );
  };
}

const App = () => {
  //when first load, check on the connection; required, otherwise if app starts and no connection, our store will keep it true and notification is not shown
  useEffectOnce(() => {
    if (
      navigator &&
      navigator.onLine == false &&
      store.getState().internetStatus == true
    ) {
      store.dispatch(setInternetStatus(false));
      store.dispatch(
        addNotification({
          type: "error",
          text: MESSAGES.youAreOffline,
          duration: notificationDurationMiddle,
          closable: true,
        })
      );
    }
  }, []);

  return (
    <Provider store={store}>
      <IntlProvider locale={"en-GB"}>
        <ThemeManager>
          <AppInit>
            <BrowserRouter forceRefresh={true}>
              <Routes />
            </BrowserRouter>
          </AppInit>
          <NotificationsManager />
          <AppLoader />
          <WelcomeScreen />
          <AppDialog />
          {/* <Dictaphone />    */}
        </ThemeManager>
      </IntlProvider>
    </Provider>
  );
};

export default App;
